import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SocialButton from './SocialButton.jsx';
import FacebookButton from "./FacebookButton";

export default class InstagramButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };

        // getInstagramAsync()
        // .then(url => this.setState({ imageUrl: url }))
        // .catch(error => console.error(error));
    }

    render() {
        const { color, profileUrl } = this.props;
        // const imageSrc = this.state.imageSrc;
        return (
            <SocialButton
                // imageSrc='https://cdn.obsess-vr.com/instagram.svg'
                style={this.props.style}
                imageSrc='https://s3.amazonaws.com/obsessvr-webstore-assets-public/instagram.svg'
                redirectUrl={profileUrl}
                color={color}
                // onClickAnalytics={FacebookButtonAnalytics}
            />
        );
    }
}

InstagramButton.propTypes = {
    style: Proptypes.object
};